import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

import { Mapper } from 'tiime-expert-utils';

import { CompanyContactsBase, CompanyContactsBaseImports } from '@bases/company-contacts/company-contacts.base';
import { CompanyContributor } from '@models/company-contributor';
import { ContributorJob } from '@models/contributor-job';

@Component({
  selector: 'app-company-contributors-contacts',
  standalone: true,
  imports: [...CompanyContactsBaseImports],
  templateUrl: './../../../core/bases/company-contacts/company-contacts.base.html',
  styleUrls: [
    './../../../core/bases/company-contacts/company-contacts.base.scss',
    './company-contributors-contacts.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyContributorsContactsComponent extends CompanyContactsBase<CompanyContributor> {
  readonly contributorJobs: InputSignal<ContributorJob[]> = input<ContributorJob[]>([]);

  readonly mapToContactPrefix: Mapper<CompanyContributor, string> = (companyContributor: CompanyContributor) => {
    const contributorJob: ContributorJob = this.contributorJobs().find(
      (contributorJob: ContributorJob) => contributorJob.id === companyContributor?.job?.id
    );
    return contributorJob ? contributorJob.customName : 'Intervenant';
  };

  readonly mapToContactFullName: Mapper<CompanyContributor, string> = (companyContributor: CompanyContributor) =>
    companyContributor.user.fullName;

  readonly mapToContactSuffix: Mapper<CompanyContributor, string> = (companyContributor: CompanyContributor) => '';

  readonly mapToContactTooltip: Mapper<CompanyContributor, string> = (companyContributor: CompanyContributor) =>
    companyContributor.user?.email;
}
